import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { PermissionEnum } from "../misc/api/ApiPermissionEnum";
import { useHasSomePermissions, useHasSomeGlobalPermissions } from "../misc/components/Authorization";

export interface PrivateRouteProps {
    permissions: PermissionEnum[] | PermissionEnum;
    children: any;
}


export const PrivateRoute = ({ permissions, children }: PrivateRouteProps) => {
    const location = useLocation();
    const wrappedPermissions = Array.isArray(permissions) ? permissions : [permissions];
    const valid = useHasSomePermissions(wrappedPermissions);

    if (!valid) {
        return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }

    return children;
};


export const PrivateRouteAllStudies = ({ permissions, children }: PrivateRouteProps) => {
    const location = useLocation();
    const wrappedPermissions = Array.isArray(permissions) ? permissions : [permissions];
    const valid = useHasSomeGlobalPermissions(wrappedPermissions);

    if (!valid) {
        return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }

    return children;
};

